import { GenreContent, type GenreLevel, GetGenresRequest } from '@app/_proto/Protos/genres';
import { GenresClient } from '@app/_proto/Protos/genres.client';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';
import { useMemo } from 'react';

type UseGenresParam = {
    level: GenreLevel;
    contentType: GenreContent[];
    enabled?: boolean;
};

type UseGenresReturn = {
    data: string[] | undefined;
    isSuccess: boolean;
    isLoading: boolean;
};

export default function useGenres({
    level,
    contentType = [GenreContent.NovelGenreContent],
    enabled,
}: UseGenresParam): UseGenresReturn {
    const getGenresRequest = useGrpcRequest(GetGenresRequest, {
        level,
        content: contentType,
    });
    const { data, isSuccess, isLoading } = useGrpcApiWithQuery(
        GenresClient,
        c => c.getGenres,
        getGenresRequest,
        ['genres', level, contentType],
        {
            enabled,
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours cache
            staleTime: 1000 * 60 * 60 * 24, // Data stales in 24 hours
        }
    );

    const genreNames = useMemo(() => {
        return data?.items?.map(genre => genre.name);
    }, [data?.items]);

    return { data: genreNames, isSuccess, isLoading };
}
